module.exports = __webpack_public_path__ + "static/media/AlexSanders.19510d0c.jpeg";